import React from "react";
import { useLang } from "../context/LangContext";

const COPY = {
  fr: [
    "L'adéquation de la séance est vérifiée au préalable. Les résultats et le nombre de séances varient selon la personne et l'indication.",
    "Cette prestation ne remplace pas un suivi médical nécessaire.",
    "Protocole, tarifs et capacité : informations communiquées par Riviera Shockwaves. Ondes de choc : STORZ MEDICAL, information patients.",
    "Visuel d'illustration ; équipe et matériel non contractuels. Les sources sur les ondes de choc ne valident pas l'ensemble du protocole combiné.",
  ],
  en: [
    "Session suitability is verified beforehand. Results and number of sessions vary by person and indication.",
    "This service does not replace required medical follow-up.",
    "Protocol, prices and capacity: information provided by Riviera Shockwaves. Shockwaves: STORZ MEDICAL, patient information.",
    "Illustrative visual; team and equipment are non-contractual. Sources on shockwaves do not validate the entire combined protocol.",
  ],
  it: [
    "L'idoneità della sessione è verificata in anticipo. I risultati e il numero di sessioni variano in base alla persona e all'indicazione.",
    "Questa prestazione non sostituisce un necessario follow-up medico.",
    "Protocollo, tariffe e capacità: informazioni comunicate da Riviera Shockwaves. Onde d'urto: STORZ MEDICAL, informazione pazienti.",
    "Visuale illustrativa; team e materiale non contrattuali. Le fonti sulle onde d'urto non convalidano l'intero protocollo combinato.",
  ],
  ru: [
    "Пригодность сеанса проверяется заранее. Результаты и количество сеансов зависят от человека и показания.",
    "Данная услуга не заменяет необходимое медицинское наблюдение.",
    "Протокол, тарифы и мощность: информация, предоставленная Riviera Shockwaves. Ударные волны: STORZ MEDICAL, информация для пациентов.",
    "Иллюстративное изображение; команда и оборудование не являются договорными. Источники по ударным волнам не подтверждают весь комбинированный протокол.",
  ],
};

export default function LegalDisclaimer() {
  const { lang } = useLang();
  const c = COPY[lang] || COPY.en;
  return (
    <section className="container-luxe pb-20" data-testid="legal-disclaimer">
      <div className="hairline-t pt-8 space-y-2">
        {c.map((line, i) => (
          <p key={i} className="text-[11px] text-[var(--ink)]/45 font-body leading-relaxed max-w-4xl">
            {line}
          </p>
        ))}
      </div>
    </section>
  );
}
